// src/components/admin/diagnostics/StandaloneDiagnosticReport.js
//
// Standalone, focused report page opened in a NEW TAB from the unified
// Diagnostic Reports / Archived Diagnostic Reports lists (both Admin and Tutor
// portals). It renders only the selected diagnostic report — no admin sidebar,
// no portal chrome — so the tab focuses on a single report.
//
// Route shape: <prefix>/diagnostics/report/:type/:variant?studentId=…&attemptId=…
//   type    ∈ { sat, psat, act }
//   variant ∈ { active, archived }
//
// The viewers below are the existing report pages, unchanged; they read
// studentId/attemptId from the query string and render the full report.

import React from "react";
import { useParams } from "react-router-dom";

import StudentReportViewer from "../dsat/reports/StudentReportViewer";
import ArchivedReportViewer from "../dsat/reports/ArchivedReportViewer";
import PSATStudentReportViewer from "../psat/reports/PSATStudentReportViewer";
import ACTStudentReportViewer from "../act/report/ACTStudentReportViewer";
import ArchivedACTStudentReportViewer from "../act/report/ArchivedACTStudentReportViewer";

function resolveViewer(type, variant) {
  const t = String(type || "").toLowerCase();
  const archived = String(variant || "").toLowerCase() === "archived";
  if (t === "act") return archived ? ArchivedACTStudentReportViewer : ACTStudentReportViewer;
  if (t === "psat") return PSATStudentReportViewer; // PSAT has no archive viewer
  return archived ? ArchivedReportViewer : StudentReportViewer; // SAT (default)
}

// forceVariant lets a portal lock the variant regardless of the URL — the Tutor
// portal forces "active" so archived reports can never be reached there.
export default function StandaloneDiagnosticReport({ forceVariant = null }) {
  const { type, variant } = useParams();
  const Viewer = resolveViewer(type, forceVariant || variant);

  return (
    <div style={{ height: "100vh", overflow: "auto", background: "#fff" }}>
      <Viewer />
    </div>
  );
}
